import React from 'react'
import { Box } from '@mui/material'
import { TagListProps } from './_props'
import Tag from './Tag'
import sxs from './TagList.sxs'

const TagList: React.FC<TagListProps> = ({ tags }) => (
    <Box sx={sxs.TagList}>
        {tags.map((label) => (
            <Tag label={label} key={label} />
        ))}
    </Box>
)

export default TagList
